import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Hero } from '../components/Hero';
import { SocialProofStrip } from '../components/SocialProofStrip';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ValueStack } from '../components/ValueStack';
import { BonusStack } from '../components/BonusStack';
import { OfferSummary } from '../components/OfferSummary';
import { TestimonialWall } from '../components/TestimonialWall';
import { Guarantee } from '../components/Guarantee';
import { FaqSection } from '../components/FaqSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { FinalCta } from '../components/FinalCta';
import { ClosingSection } from '../components/ClosingSection';
import { SiteFooter } from '../components/SiteFooter';
import { MobileCheckoutBar } from '../components/MobileCheckoutBar';
export function SalesPage() {
  return <div className="min-h-full w-full bg-paper pb-20 md:pb-0" data-id="element-272" data-mp="3ajqb0w8tqd8x">
      <AnnouncementBar data-id="element-273" data-mp="3al1awkz5f0ur" />
      <main data-id="element-274" data-mp="3aljds0gbgdbn">
        <Hero data-id="element-275" data-mp="35t9tazxz05gr" />
        <SocialProofStrip data-id="element-276" data-mp="35sqbdj8blh2q" />
        <ProblemSection data-id="element-277" data-mp="35rf8dlmp8dco" />
        <SolutionSection data-id="element-278" data-mp="35qx4c2tsouu7" />
        <ValueStack data-id="element-279" data-mp="30tnggrm20r8h" />
        <BonusStack data-id="element-280" data-mp="30t59azxussls" />
        <OfferSummary data-id="element-281" data-mp="30ugff6erucg2" />
        <TestimonialWall data-id="element-282" data-mp="30rubdgr3af2l" />
        <Guarantee data-id="element-283" data-mp="2vv3vouj75lhp" />
        <FaqSection data-id="element-284" data-mp="2vvlp7jeh5llx" />
        <ComparisonSection data-id="element-285" data-mp="2vw58p4jrwi22" />
        <FinalCta data-id="element-286" data-mp="2vsr5xv7766u3" />
        <ClosingSection data-id="element-287" data-mp="3tic9s4gvbs9o" />
      </main>
      <SiteFooter data-id="element-288" data-mp="3thj83hwrnsye" />
      <MobileCheckoutBar data-id="element-289" data-mp="3tht35jwo4qay" />
    </div>;
}